import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

export function brokerageFormValidator(): ValidatorFn {
  return (form: AbstractControl): ValidationErrors | null => {
    const brokerName = form.get('commissionIssuerName') as AbstractControl;
    const errors: any = brokerName.errors || {};

    if (
      form.get('agentIsBroker')?.value === false &&
      brokerName.value.length < 2
    ) {
      errors.required = true;
    } else {
      delete errors.required;
    }

    brokerName.setErrors(Object.keys(errors).length > 0 ? errors : null);
    return null;
  };
}
